module.exports = __webpack_public_path__ + "img/xiangnina.11e15abe.jpg";